export default (src: string) => new RegExp('.webp').test(src);
